import { createContext, useContext, useMemo } from 'react';
import { RoomContext } from '@livekit/components-react';

import { useRoom } from '../hooks/useRoom';

const SessionContext = createContext({
  agentName:"test-voice",  
  // appConfig: APP_CONFIG_DEFAULTS, // Assuming APP_CONFIG_DEFAULTS is defined elsewhere
  isSessionActive: false,
  startSession: () => {},
  endSession: () => {},
});

export default function SessionProvider({ agentName, children }) {
  const { room, isSessionActive, startSession, endSession } = useRoom(agentName);
  const contextValue = useMemo(
    () => ({ agentName, isSessionActive, startSession, endSession }),
    [agentName, isSessionActive, startSession, endSession]
  );

  return (
    <RoomContext.Provider value={room}>
      <SessionContext.Provider value={contextValue}>{children}</SessionContext.Provider>
    </RoomContext.Provider>
  );
};

export function useSession() {
  return useContext(SessionContext);
}